import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NavButtonModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { HeaderEditorialMenuLinksComponent } from './header-editorial-menu-links.component';

@NgModule({
  declarations: [HeaderEditorialMenuLinksComponent],
  imports: [CommonModule, NavButtonModule, AnalyticsModule],
  exports: [HeaderEditorialMenuLinksComponent]
})
export class HeaderEditorialMenuLinksModule {}
